<template>
	<a-dropdown
		:trigger="actions ? ['click'] : []"
		:class="actions ? 'pointer' : ''"
	>
		<a-tag
			v-if="data.VencimientoEstado===0"
			:color="$colors.warning"
			size="small"
		>
			<fa-icon
				:icon="['fas','clock']"
				class="mr-2"
			/>Pendiente <a-icon
				v-if="actions"
				type="down"
			/>
		</a-tag>
		<a-tag
			v-else-if="data.VencimientoEstado===1"
			:color="$colors.danger"
			size="small"
		>
			<fa-icon
				:icon="['fas','sad-tear']"
				class="mr-2"
			/>Impagada <a-icon
				v-if="actions"
				type="down"
			/>
		</a-tag>
		<a-tag
			v-else-if="data.VencimientoEstado===2"
			:color="$colors.success"
			size="small"
		>
			<fa-icon
				:icon="['fas','check']"
				class="mr-2"
			/>Pagada <a-icon
				v-if="actions"
				type="down"
			/>
		</a-tag>
		<a-tag v-else>
			??? <a-icon
				v-if="actions"
				type="down"
			/>
		</a-tag>

		<a-menu slot="overlay">
			<a-menu-item
				key="0"
				@click="setHitStatus(0,'pendiente')"
			>
				<span class="text-warning">
					<fa-icon
						:icon="['fas','clock']"
						class="mr-2"
					/> Pendiente
				</span>
			</a-menu-item>
			<a-menu-item
				key="2"
				@click="setHitStatus(2,'pagado')"
			>
				<span class="text-success">
					<fa-icon
						:icon="['fas','clock']"
						class="mr-2"
					/> Pagado
				</span>
			</a-menu-item>
			<a-menu-item
				key="1"
				@click="setHitStatus(1,'impagado')"
			>
				<span class="text-danger">
					<fa-icon
						:icon="['fas','clock']"
						class="mr-2"
					/> Impagado
				</span>
			</a-menu-item>
		</a-menu>
	</a-dropdown>
</template>

<script>
import _ from 'lodash';

export default {
	name: 'InvoiceHitStatus',
	props: {
		data: {
			type: Object,
			required: true
		},
		actions: {
			type: Boolean,
			default: true
		}
	},
	methods: {
		async setHitStatus(value, text) {
			const result = await this.$gestios.items('facturas_vencimientos').edit({
				id: this.data._EntityId,
				params: {
					VencimientoEstado: value
				}
			});

			if (result.ok) {
				this.$message.success(`Estado del vencimiento cambiado a ${text}`);

				const id = parseInt(this.data.Factura, 10);
				const factura = _.cloneDeep(this.$gestios.$cache.items('facturas').get(id));

				if (factura) {
					const hits = factura.Vencimientos.map((v) => {
						if (v._EntityId === this.data._EntityId) v.VencimientoEstado = value;
						return v;
					});

					const params = {
						Vencimientos: hits
					};

					const onePending = hits.findIndex((h) => h.VencimientoEstado === 0);
					const oneUnpaid = hits.findIndex((h) => h.VencimientoEstado === 1);

					if (oneUnpaid > -1) {
						params.FacturaEstado = 1;
					} else if (onePending > -1) {
						params.FacturaEstado = 0;
					} else {
						params.FacturaEstado = 2;
					}

					this.$gestios.$cache.items('facturas').edit({
						id,
						params
					});
				}
			}
		}
	}
};
</script>

<style lang="scss" scoped>

</style>
